import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import SignUp from './views/SignUp.vue'
import Websites from './views/Websites.vue'
import Assignees from './views/Assignees.vue'
import EditWebsite from './components/websites/EditWebsite.vue'
import UserList from './views/UserList.vue'
import Login from './views/Login.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/tests',
      name: 'home',
      component: Home,
      meta: {requiresAuth: true}
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp,
      meta: {requiresAuth: true, requiresAdmin: true}
    },
    {
      path: '/websites',
      name: 'websites',
      component: Websites,
      meta: {requiresAuth: true, requiresAdmin: true}
    },
    {
      path: '/website/:id?',
      name: 'editwebsite',
      component: EditWebsite,
      meta: {requiresAuth: true, requiresAdmin: true}
    },
    {
      path: '/assignees',
      name: 'assignees',
      component: Assignees,
      meta: {requiresAuth: true, requiresAdmin: true}
    },
    {
      path: '/reset',
      name: 'resret',
      component: Home
    }
  ]
})
